const UPCOMING_YEAR_WINDOW_DAYS = 31;

export const getCurrentYear = (now = new Date()) => now.getFullYear();

export const isUpcomingYearAllowed = (now = new Date()) => {
  const nextYearStart = new Date(now.getFullYear() + 1, 0, 1);
  const daysUntilNextYear = Math.ceil((nextYearStart - now) / (1000 * 60 * 60 * 24));

  return daysUntilNextYear >= 0 && daysUntilNextYear <= UPCOMING_YEAR_WINDOW_DAYS;
};

export const getMaxSelectableYear = (now = new Date()) =>
  getCurrentYear(now) + (isUpcomingYearAllowed(now) ? 1 : 0);

export const normalizeYearSettings = (settingsState = {}, now = new Date()) => {
  const currentYear = getCurrentYear(now);
  const maxSelectableYear = getMaxSelectableYear(now);
  const selectedYear = settingsState.selectedYear;
  const selectionIsValid = Number.isFinite(selectedYear) && selectedYear <= maxSelectableYear;
  const isSameCalendarYear = settingsState.calendarYear === currentYear;

  return {
    ...settingsState,
    selectedYear: selectionIsValid && isSameCalendarYear ? selectedYear : currentYear,
    calendarYear: currentYear,
  };
};
